var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHuntingtonBank = function SvgHuntingtonBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "huntington-bank_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".huntington-bank_svg__st1{fill:#70b62c}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v40H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "huntington-bank_svg__Calque_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "huntington-bank_svg__st1",
    d: "M19.3 13.8V3.6l-3.7 2.2v10.1zM20.7 26.2v10.2l3.7-2.2V24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "huntington-bank_svg__st1",
    d: "M15.6 23.3v10.9l3.7 2.2V25.5l6.4-3.7v11.6l3.7-2.1V8.7l-3.7-2.1v10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "huntington-bank_svg__st1",
    d: "m14.2 6.6-3.6 2.1v22.6l3.6 2.1V22.5l10.2-5.8V5.8l-3.7-2.2v10.9l-6.5 3.7zM9.1 9.5 6 11.3c-.3.2-.6.6-.6.8v15.6c0 .3.3.7.6.8l3.1 1.8V9.5zM30.9 30.5l3.1-1.8c.3-.2.6-.6.6-.8V12.2c0-.3-.3-.7-.6-.8l-3.1-1.8v20.9z"
  }))));
};
export default SvgHuntingtonBank;